export const formatPhoneNumber = (
  phoneNumberString: string | undefined | null,
): string => {
  if (!phoneNumberString || typeof phoneNumberString !== 'string') {
    return ''
  }

  if (
    phoneNumberString.charAt(0) === '#' ||
    phoneNumberString.charAt(0) === '*'
  ) {
    const cleaned = phoneNumberString.replace(/\D/g, '')
    return `${phoneNumberString.charAt(0)}${cleaned}`
  }

  const cleaned = phoneNumberString.replace(/\D/g, '')
  const hasPlusPrefix = phoneNumberString.trim().startsWith('+')

  if (cleaned.length <= 6 && !hasPlusPrefix) {
    return cleaned
  }

  if (hasPlusPrefix && cleaned.length === 11 && cleaned.startsWith('1')) {
    const areaCode = cleaned.substring(1, 4)
    const exchange = cleaned.substring(4, 7)
    const subscriber = cleaned.substring(7, 11)
    return `+1 (${areaCode}) ${exchange}-${subscriber}`
  }

  if (cleaned.length === 10) {
    const areaCode = cleaned.substring(0, 3)
    const exchange = cleaned.substring(3, 6)
    const subscriber = cleaned.substring(6, 10)
    return `(${areaCode}) ${exchange}-${subscriber}`
  }

  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    const areaCode = cleaned.substring(1, 4)
    const exchange = cleaned.substring(4, 7)
    const subscriber = cleaned.substring(7, 11)
    return `(${areaCode}) ${exchange}-${subscriber}`
  }

  if (hasPlusPrefix) {
    return `+${cleaned}`
  }

  return phoneNumberString
}

export const formatDuration = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds}s`
  }
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  if (minutes < 60) {
    return remainingSeconds > 0
      ? `${minutes}m ${remainingSeconds}s`
      : `${minutes}m`
  }
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60
  if (remainingMinutes > 0) {
    return `${hours}h ${remainingMinutes}m`
  }
  return `${hours}h`
}
